// extracted by mini-css-extract-plugin
export default {"photoButton":"styles_photoButton__fpt9i","invisibleFileInput":"styles_invisibleFileInput__cSZEl"};